module.exports = __webpack_public_path__ + "media/images/flags/4x3/irl-933683695409183c62c8b8a27439a0f7.svg";